import React from 'react';
import { DocumentType } from '../../../../common/constants/documentType';
import { Resource } from '../../../../common/constants/resource';
import { TaskState } from '../../../../common/constants/states';
import ElementLocators from '../../../../common/ElementLocators';
import { ITask } from '../../../tasks/interfaces/ITask';
import { MVR } from '../../../tasks/types/mvr';
import { factsExist } from '../../utilities/taskDetailUtilities';
import { RetryableEvidenceItem } from '../components/RetryableEvidenceItem';
import { MVRDetailsBody } from './MVRDetailsBody';

export const MVRDetail = ({
  task,
  retryHandler,
  markOutdatedHandler,
  uploadHandler,
  downloadHandler,
  taskStateHandler,
  deleteHandler,
}: {
  task: ITask;
  retryHandler: (taskId: number) => void;
  markOutdatedHandler: (taskId: number) => void;
  uploadHandler: (
    existingTaskData: ITask,
    data: FormData,
    type: string,
  ) => void;
  downloadHandler: (uri: string, fileName: string) => void;
  deleteHandler: (
    existingTaskData: ITask,
    documentId: number,
    reason: string,
  ) => void;
  taskStateHandler: (taskId: number, state: TaskState, reason?: string) => void;
}) => {
  const { evidence } = task;

  function renderTaskDetails() {
    const mvr: MVR | null = evidence ? (evidence.facts as MVR) : null;
    return (
      <MVRDetailsBody
        mvr={mvr}
        errorMessage={evidence?.errorMessage}
        evidenceId={task.evidenceId}
      />
    );
  }

  return (
    <div data-label={ElementLocators.LOCATOR_MVR_SECTION}>
      <RetryableEvidenceItem
        task={task}
        documentType={DocumentType.MVR}
        title={Resource.TASK_TITLE_MVR}
        downloadHandler={downloadHandler}
        uploadHandler={uploadHandler}
        deleteHandler={deleteHandler}
        retryHandler={retryHandler}
        taskStateHandler={taskStateHandler}
        markOutdatedHandler={markOutdatedHandler}
      >
        {factsExist(evidence) ? renderTaskDetails() : <></>}
      </RetryableEvidenceItem>
    </div>
  );
};
